
// // fcmFirebase.js
// import * as firebase from 'firebase';
// import 'firebase/messaging';

// const fcmConfig = {
//   apiKey: "AIzaSyAmkHGAljtJNpfh1rcJMtdabYimw_9049Q",
//   authDomain: "posible-notification.firebaseapp.com",
//   projectId: "posible-notification",
//   storageBucket: "posible-notification.firebasestorage.app",
//   messagingSenderId: "142946129749",
//   appId: "1:142946129749:web:a9542c168df6c8a07e81dc"
// };

// // Initialize separate app for FCM (different from default app)
// const fcmApp = firebase.initializeApp(fcmConfig, "posible-web");
// console.log("fcmApp",fcmApp);
// // Get messaging instance from the FCM specific app
// export const messaging = fcmApp.messaging();
// export const getFCMAppName = () => fcmApp.name;
//  console.log("FCM App name:", fcmApp.name ? fcmApp.name : "Not available");
// console.log("messaging instance:", messaging); // Add this to verify


import * as firebase from "firebase/app";
import "firebase/messaging";

const fcmConfig = {
  apiKey: "AIzaSyAmkHGAljtJNpfh1rcJMtdabYimw_9049Q",
  authDomain: "posible-notification.firebaseapp.com",
  projectId: "posible-notification",
  storageBucket: "posible-notification.firebasestorage.app",
  messagingSenderId: "142946129749",
  appId: "1:142946129749:web:a9542c168df6c8a07e81dc"
};
// Check if FCM is supported on this device/browser
const isFCMSupported = () => {
  // Check if we're in a browser environment
  if (typeof window === 'undefined') return false;
  
  // Check for iOS Safari (FCM not supported)
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  
  if (isIOS && isSafari) {
    console.log("FCM not supported on iOS Safari");
    return false;
  }
  
  // Check if Firebase messaging is available
  if (!firebase.messaging || !firebase.messaging.isSupported) {
    console.log("Firebase messaging not available");
    return false;
  }
  
  try {
    return firebase.messaging.isSupported();
  } catch (e) {
    console.log("FCM isSupported check failed:", e);
    return false;
  }
};

// Only initialize FCM if supported
let fcmApp = null;
let messaging = null;

if (isFCMSupported()) {
  try {
    fcmApp = firebase.initializeApp(fcmConfig, "posible-web");
    messaging = fcmApp.messaging();
    console.log("FCM initialized successfully");
  } catch (e) {
    console.log("FCM initialization failed:", e);
    messaging = null;
  }
} else {
  console.log("FCM not supported - skipping initialization");
}

// Export a safe messaging object (null if not supported)
export { messaging };

// Helper function to safely check FCM availability
export const isFCMAvailable = () => {
  return messaging !== null;
};